export function isSIP(item) {
  return !item.internal_number_id;
}

export function isInternal(item) {
  return !!item.internal_number_id;
}

export function isExternal(item) {
  return !item.internal_number_id && item.number;
}
